import React from 'react';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';

class AbacusSnackbar extends React.Component {

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.props.onClick(event)
  };

  render() {
    return (
      <Snackbar
          anchorOrigin={{ vertical:"bottom", horizontal:"center" }}
          open={this.props.open}
          message={this.props.message}
          action={[
            <Button key="undo" style={this.props.buttonStyle} size="small" onClick={this.handleClose}>
              Close
            </Button>,
          ]}
      />
      );
    }
  }

  export default AbacusSnackbar;